export const getChartData = (chartData, chartLabel) => {
  const STATUS_KEYS = [
    'pending',
    'approved',
    'in-progress',
    'completed',
    'delivered',
    'withdrawn',
  ];

  const LABELS = {
    pending: 'Pending',
    approved: 'Approved',
    'in-progress': 'In Progress',
    completed: 'Completed',
    delivered: 'Delivered',
    withdrawn: 'Withdrawn',
  };

  const COLORS = {
    pending: '#5a70ac',
    approved: '#009688',
    'in-progress': '#ff9800',
    completed: '#636d77',
    delivered: '#2196f3',
    withdrawn: '#f44336',
  };

  return {
    labels: STATUS_KEYS.map(key => LABELS[key]),
    datasets: [
      {
        label: chartLabel,
        data: STATUS_KEYS.map(key => (chartData[key] || []).length),
        backgroundColor: STATUS_KEYS.map(key => COLORS[key]),
        borderColor: STATUS_KEYS.map(key => COLORS[key]),
        borderWidth: 0,
        outerRadius: '100%',
        innerRadius: '99%',
        cornerRadius: '7%',
        padAngle: '10',
      },
    ],
  };
};

export const doughnutOptions = {
  cutout: 45,
  plugins: {
    legend: false,
  },
  responsive: false,
  maintainAspectRatio: false,
};
